import { publicClient, privateClient } from './client';
import { OrderHistoryStatus } from './OrderHistoryStatus';

const customOrderHistoryStatus = (pub: boolean) => new OrderHistoryStatus(pub ? publicClient : privateClient);
export default customOrderHistoryStatus;
